import React, { useEffect, useState } from "react";

import {
  casinoBetAPI,
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "react-query";


import { useLocation } from "react-router-dom";
import {
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./casinoConstant";
import { casinoPL, cricketFancyPL } from "../../utils/profitLoss";
import toast from "react-hot-toast";
import { getProfit } from "../../utils/constants";

export default function AAA({
  GAME_ID,
  shortName,
}) {
  // const GAME_ID = "ABJ";

  const dispatch = useDispatch();
  const lastTenResultData = useQuery(
    "getResult",
    () => getCasinoLastTenResultAPI("aaa"),
    {
      refetchInterval: 1500,
    }
  );
  const [casinoPlData, setCasinoPlData] = useState([]);
  const casinoData = useQuery("getCasinoOdds", () => getCasinoOddsAPI("aaa"), {
    refetchInterval: 800,
  });
  const [loading, setIsLoading] = useState(false);
  const betPlace = async () => {
    let delay = 1500;
    setIsLoading(true);
    setTimeout(async () => {
      let selectedAmount_ = selectedEventForBet?.amount;
      if (selectedEventForBet.selectedOdd <= 0) {
        toast.error("Please select a Valid Odd");
        setIsLoading(false);
        return;
      }

      let payload = {
        amount: selectedAmount_,
        marketId: selectedEventForBet?.marketId,
        runnerName: selectedEventForBet?.runnerName,
        selectionId: selectedEventForBet?.selectedId,
        casinoGames: "aaa",
        back: selectedEventForBet?.selectedOdd,
        run: selectedEventForBet?.run,
        type: selectedEventForBet?.type,
      };

      if (selectedEventForBet?.type === "lay") {
        delete payload.back;
        payload.lay = selectedEventForBet?.selectedOdd;
      }
      // if (GAME_ID === "RACE20") {
      //   let calculation = cricketMatchOddsPL(
      //     selectedEventForBet?.selectedOdd,
      //     selectedAmount_,
      //     selectedEventForBet?.type
      //   );
      //   payload.profit = parseFloat(calculation?.profit).toFixed(2);

      //   payload.loss = parseFloat(calculation?.loss).toFixed(2);
      // }

      let { data, response, status, code } = await casinoBetAPI(payload);
      if (code == 200) {
        toast.success("Bet Placed");
      } else if (code == 500) {
        toast.error(status);
      } else if (code == "ERR_BAD_RESPONSE") {
        toast.error(status);
      } else {
        toast.error(status);
      }

      dispatch({
        type: "gameData/setSelectedEventForBet",
        payload: null,
      });
      setIsLoading(false);
    }, delay);
  };

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);
  const selectedEventForBet = useSelector(
    (state) => state.gameData.selectedEventForBet
  );
  const handleAmountChange = (amount = 100) => {
    let calculation;

    calculation = casinoPL(
      selectedEventForBet?.selectedOdd,
      amount,
      selectedEventForBet?.type
    );
    dispatch({
      type: "gameData/setSelectedEventForBet",
      payload: {
        ...selectedEventForBet,
        amount,
        profit: calculation.profit,
        loss: calculation.loss,
      },
    });
  };






  let changeShortName = shortName;
  if (GAME_ID == "aaa2") {
    changeShortName = "aaa";
  }

  const casinoCardMap = (_) => {
    let cardMap = {
      aaa: 7

    }

  }

  return (
    <div className="container">
      <div className="row margin0">
        <div className="col-12 padding0">
          <div className="game-header">
            <span>AAA</span>
            <span>
              {" "}
              RoundId : {casinoData?.data?.response?.marketId}{" "}
              <button className="rules-btn btn btn-warning btn-sm">
                Rules
              </button>
            </span>
          </div>
          <div className="row margin0">
            <div className="col-12 padding0" style={{ position: "relative" }}>
              <iframe
                src="https://dfii.live/casino?id=aaa"
                height={400}
                width="100%"
                scrolling="auto"
                className="liveStr"
              />
              {casinoData?.data?.response?.cards && casinoData?.data?.response?.cards.length > 0 && (
                <div
                  _ngcontent-ng-c1798067373=""
                  className="casino-video-cards ng-tns-c1798067373-0 ng-star-inserted"
                >
                  <div
                    _ngcontent-ng-c1798067373=""
                    className="ab-cards-container ng-tns-c1798067373-0"
                  >
                    <div
                      _ngcontent-ng-c1798067373=""
                      className="row row5 align-items-center ng-tns-c1798067373-0"
                    >
                      <div
                        _ngcontent-ng-c1798067373=""
                        className="col-1 ng-tns-c1798067373-0"
                      >
                        <div
                          _ngcontent-ng-c1798067373=""
                          className="row row5 ng-tns-c1798067373-0"
                        >
                          <div
                            _ngcontent-ng-c1798067373=""
                            className="col-12 ng-tns-c1798067373-0"
                          >
                            {/* <b
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-0"
                    >
                      A
                    </b> */}
                          </div>
                        </div>
                        <div
                          _ngcontent-ng-c1798067373=""
                          className="row row5 ng-tns-c1798067373-0"
                        >
                          <div
                            _ngcontent-ng-c1798067373=""
                            className="col-12 ng-tns-c1798067373-0"
                          >
                            {/* <b
                      _ngcontent-ng-c1798067373=""
                      className="ng-tns-c1798067373-0"
                    >
                      B
                    </b> */}
                          </div>
                        </div>
                      </div>
                      <div
                        _ngcontent-ng-c1798067373=""
                        className="col-2 ng-tns-c1798067373-0"
                      >
                        <div
                          _ngcontent-ng-c1798067373=""
                          className="flip-card ng-tns-c1798067373-0"
                        >
                          <div
                            _ngcontent-ng-c1798067373=""
                            className="flip-card-inner ng-tns-c1798067373-0"
                          >
                            <div
                              _ngcontent-ng-c1798067373=""
                              className="flip-card-front ng-tns-c1798067373-0"
                            >
                              <img
                                _ngcontent-ng-c1798067373=""
                                className="ng-tns-c1798067373-0"
                                src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${casinoData?.data?.response?.cards[0][0]
                                  }.jpg`}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        _ngcontent-ng-c1798067373=""
                        className="col-9 ng-tns-c1798067373-0 ng-star-inserted"
                      >
                        <div
                          _ngcontent-ng-c1798067373=""
                          className="row row5 mb-1 ng-tns-c1798067373-0"
                        >
                          <div
                            _ngcontent-ng-c1798067373=""
                            className="col-lg-10 col-9 ng-tns-c1798067373-0"
                          >
                            <div
                              _ngcontent-ng-c1798067373=""
                              className="casino-result-cards col-lg-12 ng-tns-c1798067373-0"
                            >
                              <div
                                _ngcontent-ng-c1798067373=""
                                className="casino-result-cardimg ng-tns-c1798067373-0"
                              >
                                <div
                                  _ngcontent-ng-c1798067373=""
                                  className="andar-bhar2-cards-slider ng-tns-c1798067373-0"
                                >
                                  {/**/}
                                  {/**/}
                                  {/**/}
                                  {/**/}
                                  <div
                                    _ngcontent-ng-c1798067373=""
                                    className="draggable ng-tns-c1798067373-0"
                                  >
                                    {casinoData?.data?.response?.cards[1]?.map(
                                      (item) =>
                                        item != "1" && (
                                          <img
                                            _ngcontent-ng-c1798067373=""
                                            onerror="this.src='assets/images/cards/1.jpg'"
                                            className="ng-tns-c1798067373-0"
                                            src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                                          />
                                        )
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          _ngcontent-ng-c1798067373=""
                          className="row row5 mb-1 ng-tns-c1798067373-0"
                        >
                          <div
                            _ngcontent-ng-c1798067373=""
                            className="col-lg-10 col-9 ng-tns-c1798067373-0"
                          >
                            <div
                              _ngcontent-ng-c1798067373=""
                              className="casino-result-cards col-lg-12 ng-tns-c1798067373-0"
                            >
                              <div
                                _ngcontent-ng-c1798067373=""
                                className="casino-result-cardimg ng-tns-c1798067373-0"
                              >
                                <div
                                  _ngcontent-ng-c1798067373=""
                                  className="andar-bhar2-cards-slider ng-tns-c1798067373-0"
                                >
                                  {/**/}
                                  {/**/}
                                  {/**/}
                                  {/**/}
                                  <div
                                    _ngcontent-ng-c1798067373=""
                                    className="draggable ng-tns-c1798067373-0"
                                  >
                                    {casinoData?.data?.response?.cards[2]?.map(
                                      (item) =>
                                        item != "1" && (
                                          <img
                                            _ngcontent-ng-c1798067373=""
                                            onerror="this.src='assets/images/cards/1.jpg'"
                                            className="ng-tns-c1798067373-0"
                                            src={`https://versionobj.ecoassetsservice.com/v26/static/front/img/cards/${item}.jpg`}
                                          />
                                        )
                                    )}
                                    {/**/}
                                    {/**/}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/**/}
                    </div>
                  </div>
                </div>

              )}

              {/* <div className="col-12  res-box"> */}
              {/* <img
                  src="/images/cards/KHH.png"
                  className="ab2-res-fst-card"
                /> */}

              {/* </div> */}
            </div>
          </div>
          <div className="row andarbahar-module mr-left-right">
            <div
              className="row mr-left-right lucky7-main"
              style={{ width: "100%" }}
            >
              <div className="col-md-4 col-lg-4 col-xs-4 col-sm-4 lucky7-main-bhav">
                <span className="col-12 col-md-12 casino-profit-text">
                  A.Amar
                </span>
                <span className="col-12 aaa-bhav" style={{ padding: 0 }}>
                  <div
                    className="col-6 col-md-6 lucky7-bhav back"
                    style={{ padding: 0 }}
                    onClick={() =>
                      setBet("Amar", casinoData, dispatch, "back")
                    }
                  >
                    <span style={{ position: "relative" }}>
                      {casinoData?.data?.response?.autoTime < 5 && (
                        <div className="susb-bhav">
                          <img src="https://hrx99.com/images/cards/padlock.png" />
                        </div>
                      )}
                      {getOddForEntity("Amar", casinoData)}{" "}
                    </span>
                  </div>
                  <div
                    className="col-6 col-md-6 lucky7-bhav lay"
                    style={{ padding: 0 }}
                    onClick={() =>
                      setBet("Amar", casinoData, dispatch, "lay")
                    }
                  >
                    <span style={{ position: "relative" }}>
                      {casinoData?.data?.response?.autoTime < 5 && (
                        <div className="susb-bhav">
                          <img src="https://hrx99.com/images/cards/padlock.png" />
                        </div>
                      )}
                      {getOddForEntity("Amar", casinoData, false)}{" "}
                    </span>
                  </div>
                </span>
                {/* <span className="col-12 col-md-12 casino-profit-text">
                  {getOddForEntity("Amar", casinoData, true)}{" "}
                </span>
              */}
                <span className="col-12 col-md-12 casino-profit-text">
                  {getCasinoPlExposureByRunner(
                    casinoPlData,
                    "Amar",
                    casinoData?.data?.response?.marketId
                  )}{" "}
                </span>
              </div>
              <div
                className="col-4 col-md-4 lucky7-main-bhav"
                style={{ paddingRight: 0, paddingLeft: 5 }}
              >
                <span className="col-12 col-md-12 casino-profit-text">
                  B.Akbar
                </span>
                <span
                  className="col-12 col-md-12 aaa-bhav"
                  style={{ padding: 0 }}
                >
                  <div
                    className="col-6 col-md-6 lucky7-bhav back"
                    style={{ padding: 0 }}
                    onClick={() =>
                      setBet("Akbar", casinoData, dispatch, "back")
                    }
                  >
                    <span style={{ position: "relative" }}>
                      {casinoData?.data?.response?.autoTime < 5 && (
                        <div className="susb-bhav">
                          <img src="https://hrx99.com/images/cards/padlock.png" />
                        </div>
                      )}
                      {getOddForEntity("Akbar", casinoData)}{" "}
                    </span>
                  </div>
                  <div
                    onClick={() =>
                      setBet("Akbar", casinoData, dispatch, "lay")
                    }
                    className="col-6 col-md-6 lucky7-bhav lay"
                    style={{ padding: 0 }}
                  >
                    <span style={{ position: "relative" }}>
                      {casinoData?.data?.response?.autoTime < 5 && (
                        <div className="susb-bhav">
                          <img src="https://hrx99.com/images/cards/padlock.png" />
                        </div>
                      )}
                      {getOddForEntity("Akbar", casinoData, false)}{" "}
                    </span>
                  </div>
                </span>
                <span className="col-12 col-md-12 casino-profit-text">
                  {getCasinoPlExposureByRunner(
                    casinoPlData,
                    "Akbar",
                    casinoData?.data?.response?.marketId
                  )}{" "}
                </span>
              </div>
              <div
                className="col-4 col-md-4 lucky7-main-bhav"
                style={{ paddingRight: 0, paddingLeft: 5 }}
              >
                <span className="col-12 col-md-12 casino-profit-text">
                  C.Anthony
                </span>
                <span
                  className="col-12 col-md-12 aaa-bhav"
                  style={{ padding: 0 }}
                >
                  <div
                    className="col-6 col-md-6 lucky7-bhav back"
                    style={{ padding: 0 }}
                    onClick={() =>
                      setBet("Anthony", casinoData, dispatch, "back")
                    }
                  >
                    <span style={{ position: "relative" }}>
                      {casinoData?.data?.response?.autoTime < 5 && (
                        <div className="susb-bhav">
                          <img src="https://hrx99.com/images/cards/padlock.png" />
                        </div>
                      )}
                      {getOddForEntity("Anthony", casinoData, true)}{" "}
                    </span>
                  </div>
                  <div
                    className="col-6 col-md-6 lucky7-bhav lay"
                    style={{ padding: 0 }}
                    onClick={() =>
                      setBet("Anthony", casinoData, dispatch, "lay")
                    }
                  >
                    <span style={{ position: "relative" }}>
                      {casinoData?.data?.response?.autoTime < 5 && (
                        <div className="susb-bhav">
                          <img src="https://hrx99.com/images/cards/padlock.png" />
                        </div>
                      )}
                      {getOddForEntity("Anthony", casinoData, false)}{" "}
                    </span>
                  </div>
                </span>
                <span className="col-12 col-md-12 casino-profit-text">
                  {getCasinoPlExposureByRunner(
                    casinoPlData,
                    "Anthony",
                    casinoData?.data?.response?.marketId
                  )}{" "}
                </span>

                {/* <span className="col-12 col-md-12 casino-profit-text">
                  {getOddForEntity("Anthony", casinoData, true)}{" "}
                </span> */}
              </div>
            </div>
            <div className="row mr-left-right lucky7-main">
              <div className="col-6 col-md-3 lucky7-main-bhav">
                <span className="col-12 col-md-12 casino-profit-text">
                  {getOddForEntity("EVEN", casinoData)}{" "}
                </span>
                <div
                  onClick={() => setBet("EVEN", casinoData, dispatch)}
                  className="col-12 col-md-12 lucky7-bhav"
                >
                  <button>
                    {casinoData?.data?.response?.autoTime < 5 && (
                      <div className="susb-bhav">
                        <img src="https://hrx99.com/images/cards/padlock.png" />
                      </div>
                    )}
                    EVEN
                  </button>
                </div>
                <div style={{ color: "red" }}>
                  {getCasinoPlExposureByRunner(
                    casinoPlData,
                    "EVEN",
                    casinoData?.data?.response?.marketId
                  )}
                </div>
              </div>
              <div className="col-6 col-md-3 lucky7-main-bhav">
                <span className="casino-profit-text">
                  {getOddForEntity("ODD", casinoData)}{" "}
                </span>
                <div
                  onClick={() => setBet("ODD", casinoData, dispatch)}
                  className="col-12 col-md-12 lucky7-bhav"
                >
                  <button>
                    {casinoData?.data?.response?.autoTime < 5 && (
                      <div className="susb-bhav">
                        <img src="https://hrx99.com/images/cards/padlock.png" />
                      </div>
                    )}
                    ODD
                  </button>
                </div>
                <div style={{ color: "red" }}>
                  {getCasinoPlExposureByRunner(
                    casinoPlData,
                    "ODD",
                    casinoData?.data?.response?.marketId
                  )}{" "}
                </div>
              </div>
              <div className="col-6 col-md-3 lucky7-main-bhav">
                <span className="col-12 col-md-12 casino-profit-text">
                  {getOddForEntity("RED", casinoData)}{" "}
                </span>
                <div
                  onClick={() => setBet("RED", casinoData, dispatch)}
                  className="col-12 col-md-12 lucky7-bhav"
                >
                  <button>
                    {casinoData?.data?.response?.autoTime < 5 && (
                      <div className="susb-bhav">
                        <img src="https://hrx99.com/images/cards/padlock.png" />
                      </div>
                    )}
                    <img
                      src="https://hrx99.com/images/cards/heart.png"
                      className="tpatti-img-height"
                    />
                    <img
                      src="https://hrx99.com/images/cards/diamond.png"
                      className="tpatti-img-height"
                    />
                  </button>
                </div>
                <div style={{ color: "red" }}>
                  {getCasinoPlExposureByRunner(
                    casinoPlData,
                    "RED",
                    casinoData?.data?.response?.marketId
                  )}{" "}
                </div>
              </div>
              <div className="col-6 col-md-3 lucky7-main-bhav">
                <span className="casino-profit-text">
                  {getOddForEntity("BLACK", casinoData)}{" "}
                </span>
                <div
                  onClick={() => setBet("BLACK", casinoData, dispatch)}
                  className="col-12 col-md-12 lucky7-bhav"
                >
                  <button>
                    {casinoData?.data?.response?.autoTime < 5 && (
                      <div className="susb-bhav">
                        <img src="https://hrx99.com/images/cards/padlock.png" />
                      </div>
                    )}
                    <img
                      src="https://hrx99.com/images/cards/ace-of-spades.png"
                      className="tpatti-img-height"
                    />
                    <img
                      src="https://hrx99.com/images/cards/clover-ace.png"
                      className="tpatti-img-height"
                    />
                  </button>
                </div>
                <div style={{ color: "red" }}>
                  {getCasinoPlExposureByRunner(
                    casinoPlData,
                    "BLACK",
                    casinoData?.data?.response?.marketId
                  )}{" "}
                </div>
              </div>
            </div>
            <div className="row mr-left-right lucky7-main">
              <div className="col-12 col-md-12 lucky7-main-bhav">
                <span className="casino-profit-text">{getOddForEntity("Card A", casinoData, true)}</span>
              </div>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].map((item) => (
                <span
                  className="col-2"
                  onClick={() => setBet(`Card${item}`, casinoData, dispatch)}
                  style={{ padding: 0, position: "relative" }}
                >
                  {casinoData?.data?.response?.autoTime < 5 && (
                    <div className="susb-bhav">
                      <img src="https://hrx99.com/images/cards/padlock.png" />
                    </div>
                  )}
                  <div className="lucky7-main-bhav-card">
                    <img
                      src={`https://hrx99.com/images/cards/${item}.jpg`}
                      style={{ height: 50 }}
                    />
                  </div>
                  <div style={{ color: "red" }}>
                    {getCasinoPlExposureByRunner(
                      casinoPlData,
                      "item",
                      casinoData?.data?.response?.marketId
                    )}{" "}
                  </div>

                  {/* <div style={{ color: "red" }}>0.00 </div> */}
                </span>
              ))}
            </div>
          </div>
          {selectedEventForBet && (
            <div className="numeric-keypad-main-div numeric-keypad-main-div-session d-md-none">
              <table className="done-button-table">
                <tbody>
                  <tr>
                    <td className="clear-button-td cls-td">
                      <input
                        type="button"
                        defaultValue="CANCEL"
                        style={{
                          border: "none",
                          background: "rgb(0, 0, 0)",
                          color: "rgb(255, 255, 255)",
                          fontSize: 22,
                          fontWeight: "bold",
                        }}
                      />
                    </td>
                    <td
                      className="numpad-done-button cls-td"
                      style={{
                        background: "rgb(0, 0, 0)",
                        color: "rgb(255, 255, 255)",
                      }}
                    >
                      <button
                        onClick={betPlace}
                        disabled={loading}
                        type="button"
                        style={{
                          border: "none",
                          background: "rgb(0, 0, 0)",
                          color: "rgb(255, 255, 255)",
                          fontSize: 22,
                          fontWeight: "bold",
                        }}
                      >
                        {loading ? "PLACING..." : "DONE"}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="market-rate-table">
                <tbody>
                  <tr>
                    <td
                      width="50%"
                      className="cls-td text-white"
                      style={{
                        fontWeight: "bold",
                        fontSize: 14,
                        textTransform: "uppercase",
                        background: "rgb(42, 54, 59)",
                        color: "rgb(255, 255, 255)",
                      }}
                    >
                      {selectedEventForBet?.runnerName}
                    </td>
                    <td
                      className="cls-td"
                      style={{ fontWeight: "bold", fontSize: 18 }}
                    >
                      {selectedEventForBet?.amount}
                    </td>
                    <td
                      className="cls-td text-white"
                      style={{
                        fontWeight: "bold",
                        fontSize: 16,
                        textAlign: "center",
                        background: "rgb(42, 54, 59)",
                        color: "rgb(255, 255, 255)",
                      }}
                    >
                      RATE : {selectedEventForBet?.odds}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="num-pad Input-close-table">
                <tbody>
                  <tr>
                    <td width="100%">
                      <input
                        type="number"
                        id="stakeInput"
                        placeholder="Enter Stakes"
                        value={selectedEventForBet?.amount}
                        onChange={(e) => handleAmountChange(e.target.value)}
                        className="quantity-session"
                        style={{
                          width: "100%",
                          fontSize: 18,
                          color: "rgb(0, 0, 0)",
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          <div className="game-header">
            <span>Last Result</span>
            <span>
              <a
                title="Viewl All"
                href="/"
                style={{ color: "rgb(255, 255, 255)" }}
              >
                View All
              </a>
            </span>
          </div>
          <div className="col-12 result-section">
            {lastTenResultData?.data?.data?.casinoMarketHistoryResponseDTOS?.map(
              (item) => (
                <span className="game-result playerb">
                  {item?.mainWinner}
                </span>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
